import { ReactNode } from 'react';
import './Checkbox.css';

interface IBaseCheckboxProps {
    label?: string;
    children?: ReactNode;
    checked: boolean;
    onChange: () => void;
    classes?: string;
    highlightLabel?: boolean;
    color?: "standard" | "alternative";
}

type ICheckboxProps = 
    | (IBaseCheckboxProps & { label: string; children?: ReactNode })
    | (IBaseCheckboxProps & { children: ReactNode; label?: string });

const Checkbox = ({ label, children, checked, onChange, classes, highlightLabel = false, color = "standard" }: ICheckboxProps) => {
    const checkedHighlight = checked && highlightLabel ? "checkbox-label-highlight" : "";
    return (
        <label className={`checkbox ${classes || ""}`}>
            <input 
                type="checkbox" 
                checked={checked} 
                onChange={onChange} 
                className={`checkbox-input ${color === "alternative" ? "checkbox-alternative" : ""}`}
            />
            <span className="checkbox-box" />
            <span className={`checkbox-label ${checkedHighlight}`}>{label || children}</span>
        </label>
    );
};

export default Checkbox;
